import { defineStore } from "pinia";
import { useHighlightsField } from "./lib/useHighlightsField";

export const useCurationImportantInformation = defineStore("curation-content-important-information-field", () => {
  return useHighlightsField({
    id: "important_information",
    fieldKey: "important_information",
    masterDataStoreKey: "importantInformation",
    searchPlaceholderKey: "experience.premade.search.important_to_know",
  });
});
